<template>
    <span v-loading.fullscreen.lock="fullScreenLoading">
  
      <el-dialog
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        :append-to-body="true"
        title=""
        width="80%"
        top="8vh"
         @opened="openDialog"
      >
      <el-row>
        <el-col :span="20">
            <div class="center" style="width:100%;height:75vh;">
                <video :ref="myref" :id="myref" class="video-js vjs-default-skin vjs-big-play-centered" ></video>
            </div>
        </el-col>
        <el-col :span="4">
            <div class="list-box">
                <div v-for="(item, index) in list" :key="index" :class="[ index==nowIndex ? 'select-list-item' : '',    'list-item', ]" @click="changeVideo(item, index)">
                    {{item.sources_name}}
                </div>
            </div>
        </el-col>
      </el-row>

  
      </el-dialog>
    </span>
  </template>
  
  <script>
  
  import { defineComponent, onMounted, ref } from "vue";
  import videojs from "video.js";
  import { albumSourceShareList } from "@/api";

  export default {
    name: 'AlbumShow',
    props: {
      firstList: {
        type: Object,
        default: () => {
          return {}
        }
      },
      course: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    inject: [],
    data() {
      return {
        dialogVisible: false,
        fullScreenLoading: false,
        source_prefix:process.env.VUE_APP_UPYUN_PATH,
        isError: false,
        myref:"videoPlayer",
        src:"",
        nowIndex:0,
        list:[],
        poster:"",
        player: null,
        options: {
            autoplay: false,
            controls: true,
            playbackRates: [0.5, 1, 1.5, 2],
            sources: [
                {
                    src:"",
                    type: "video/mp4"
                }
            ],
            bigPlayButton: true,
            controlBar: {
                fullscreenToggle: true,
                // 音量条的横向还是纵向显示
                volumePanel: {
                inline: false,
                },
            }, 
        }
      }
    },
    watch: {
  
    },
    created() { },
    methods: {
      show(data) {
        this.nowIndex = 0
        data.limit = 99
        albumSourceShareList(data).then(response => {
            this.list = response.data
            var url = this.source_prefix + response.data[0].sources_url
            this.options.sources[0].src = url
            this.src = url
            this.myref = "videoPlayer_" + Date.now()
    
            this.dialogVisible = true
                
        })

  
      },

      changeVideo(item, index)
      {
        this.nowIndex = index

        var url = this.source_prefix + item.sources_url
        this.options.sources[0].src = url
        this.src = url
        this.createPlayer()

      },
      createPlayer()
      {
  
          if(!this.player)
          {
              this.player = videojs(this.myref, this.options, function onPlayerReady() {
       
              })  
          }
          else
          {
             this.player.src({
                  src:this.src,
                  type: "video/mp4"
              })
  
  
          }
  
      },
      handleClose()
      {
          this.dialogVisible = false
  
          if (this.player) {
              this.player.pause()
          }
      },
      openDialog()
      {
     
          this.createPlayer()
      },
  
  
    },
    beforeDestroy() {
  
          if (this.player) {
              this.player.pause()
          }
      }
  }
  </script>
  
  
  <style>

    .list-box{
        padding-top:20px;
        height:75vh;
        background-color:#DCDFE6;
        margin-left:30px;
        color:#fff;
    }

    .list-item{
        padding-left:30px;
        padding-right:30px;
        font-size: 16px;
        line-height: 16px;
        margin-bottom:10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
     
    }

    .list-item:hover{
        color:#409EFF;
    }

    .select-list-item
    {
        color:#409EFF;
    }



      .video-js{
          width:100%;
          height:75vh;
      }
      .vjs-big-play-button {
          height: 3em !important;
          width: 3em !important;
          line-height: 3em !important;
          border-radius: 50% !important;
      }
  
      .vjs-button > .vjs-icon-placeholder:before {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 2em;
      }
  
      .vjs-slider-horizontal .vjs-volume-level:before {
          top: -0.333333333333333em;
          right: -0.5em;
      }
  
      .vjs-playback-rate .vjs-playback-rate-value {
          font-size: 1.8em;
          display: flex;
          align-items: center;
          justify-content: center;
      }
  
      .vjs-control-bar {
          background: rgba(0,0,0,.8) !important;
      }
  
      .video-js .vjs-play-progress, .video-js .vjs-volume-level {
          background: linear-gradient(to right, #FF7B02, #FFA604) !important;
      }
  
      .video-js:hover .vjs-big-play-button, .vjs-custom-skin > .video-js .vjs-big-play-button:focus, .vjs-custom-skin > .video-js .vjs-big-play-button:active {
          background: linear-gradient(to right, #FF7B02, #FFA604) !important;
          opacity: .7;
      }
  
      .vjs-big-play-button .vjs-icon-placeholder {
          font-size: 70px !important;
      }
  
      .vjs-error .vjs-error-display:before {
          color: #fff !important;
          content: 'X' !important;
          font-family: Arial, Helvetica, sans-serif !important;
          font-size: 4.5em !important;
          left: 0 !important;
          line-height: 1.8 !important;
          margin-top: -0.5em !important;
          position: absolute !important;
          text-shadow: 0.05em 0.05em 0.1em #000 !important;
          text-align: center !important;
          top: 50% !important;
          vertical-align: middle !important;
          width: 100% !important;
      }
  </style>
  